import { COMMAND_TOPICS } from './types/CommandTopics';
export function isCommandTopic(topic) {
  return COMMAND_TOPICS.includes(topic);
}